import BlogContent from "./BlogContent";
import {React, useEffect, useState } from "react";
import createClient from '../Client';

// news/blog component wrapper
const Blog = ()  => {
    const[blogData, setBlogData] = useState([]);

    useEffect(() => {
      createClient.fetch(`*[_type == 'news' && !(_id in path('drafts.**'))] | order(_createdAt desc){
        "id": _id,
        "image":news_featured_image.asset->url,
        "metaDate": news_release_date,
        "blogTitle":news_title,
        "blogDesc": news_description,
        "blogSlug": news_slug.current,
        "blogBannerImage":news_banner_image.asset->url,
        "blogbannerImageEnable":news_banner_check,
        }`).then((data) => {
            setBlogData(data);
        })
      .catch(console.error);
  },[])

    return(
        <section className="blog p-top-70">
            <div className="container">
               <BlogContent blogContent={blogData}></BlogContent>
            </div>
        </section>   
    );
}

export default Blog;